import { PayoutsCashTokenRequest } from "@kushki/js/lib/types/payouts_cash_request";
import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input as InputField } from "components/Input/InputComponent";
import { Footer } from "components/UI/Footer/FooterComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import {
  getPayoutCashToken,
  setDirty,
  updateInput,
  updatePayoutCashDocumentType,
} from "containers/PayoutsCash/store/ActionCreators";
import { get } from "lodash";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Input, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  CurrencyEnum,
  CurrencyEnumPayoutsCash,
} from "root/shared/CurrencyEnum";
import {
  colombiaDocumentTypes,
  DocumentTypesPayoutsCashEnum,
  mexicoDocumentTypes,
  peruDocumentTypes,
} from "root/shared/DocumentTypes";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import {
  calculateTotalAmount,
  checkValidity,
  getCashOutImage,
} from "root/shared/Utility";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { IPayoutsCashFormProps } from "types/cajita_store";
import { IdDocumentType } from "types/document_type";
import { IPayoutsCashActionCreator } from "types/payouts_cash_action_creator";
import { ITransferAmount } from "types/transfer_amount";
import "./assets/css/styles.css";

/**
 * Cash StateFull Component
 */
class PayoutCash extends React.Component<
  IPayoutsCashFormProps & LocalizeContextProps,
  { documentTypesArray: IdDocumentType[] }
> {
  constructor(props: IPayoutsCashFormProps & LocalizeContextProps) {
    super(props);
    this.props.addTranslation(this.props.translation);
    this.state = { documentTypesArray: [] };
    this._inputHandler = this._inputHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
  }

  public componentDidMount(): void {
    const documentTypesArray: IdDocumentType[] = this._getDocumentTypesArray();

    this.setState({
      documentTypesArray,
    });

    this.props.updatePayoutCashDocumentType(documentTypesArray[0].mnemonic);
  }

  public componentDidUpdate(): void {
    // istanbul ignore else
    if (this.props.token !== undefined && this.props.token !== "")
      sendParametersToParent({
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.PAYOUTS_CASH,
      });

    return;
  }

  public render(): React.ReactNode {
    return !this.props.isCashOutAvailable ? (
      <Container>
        <Row className={"text-center"}>
          <Col>
            <h4>
              <Translate id="notAvailableCash" />
            </h4>
          </Col>
        </Row>
        <div className={"pseImage"} />
        <div className={"poweredBy"} />
      </Container>
    ) : (
      <form onSubmit={this._submitHandler} autoComplete="off" noValidate={true}>
        <ErrorMessage />

        <div className="cash-out-container">
          <div className="section">
            <Row>
              <Col xs="12" sm="12" lg="12" xl="12">
                <div
                  className={`${getCashOutImage(
                    this.props.currency
                  )} mb-4 mt-0`}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="12" lg="12" xl="12">
                <InputField
                  {...this.props.nameInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
              <Col xs="12" sm="12" lg="12" xl="12" className="mt-1 mt-sm-0">
                <InputField
                  {...this.props.lastNameInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="6" sm="2" className="mb-1 mb-sm-0 pr-sm-0">
                {this._renderDocumentTypes()}
              </Col>
              <Col xs="12" sm="10" className="mt-3 mt-sm-0">
                <InputField
                  {...this.props.identificationInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <div className="section">
            <Row>
              <Col
                xs="12"
                sm="12"
                lg="12"
                xl="12"
                className="email-cash-out-input"
              >
                <InputField
                  {...this.props.email}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <div className="section">
            <Row>
              <Col>
                <InputField
                  {...this.props.description}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>
          <PayButton
            isValid={this.props.isValid}
            totalAmount={this.props.cashAmount}
            isSubscription={false}
            isPayout={true}
            currency={this.props.currency}
            disable={this.props.disablePayButton}
          />
        </div>

        <Footer showLanguajeToggle={this.props.isLanguageToggleAvailable} />
      </form>
    );
  }

  private _getDocumentTypesArray(): IdDocumentType[] {
    let documentTypesArray: IdDocumentType[] = [];

    switch (this.props.currency) {
      case CurrencyEnum.MXN:
        documentTypesArray = mexicoDocumentTypes;
        break;
      case CurrencyEnum.PEN:
        documentTypesArray = peruDocumentTypes;
        break;
      case CurrencyEnum.COP:
        documentTypesArray = colombiaDocumentTypes;
        break;
      default:
        documentTypesArray = colombiaDocumentTypes;
        break;
    }

    return documentTypesArray;
  }

  private _renderDocumentTypes(): JSX.Element {
    return (
      <Input
        type="select"
        name="select"
        id={"selectDocumentType"}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          this.props.updatePayoutCashDocumentType(e.target.value);
        }}
        required={true}
      >
        {this.state.documentTypesArray.map(
          (item: IdDocumentType, key: number) => (
            <option key={key}>{item.mnemonic}</option>
          )
        )}
      </Input>
    );
  }

  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    const cashOutTokenRequest: PayoutsCashTokenRequest = {
      currency: get(this.props, "currency", "") as CurrencyEnumPayoutsCash,
      documentType: get(
        this.props,
        "documentType",
        ""
      ) as DocumentTypesPayoutsCashEnum,
      documentNumber: this.props.identificationInput.value,
      name: this.props.nameInput.value,
      lastName: this.props.lastNameInput.value,
      totalAmount: this.props.cashAmount,
      email: get(this.props.email, "value", ""),
      description: get(this.props.description, "value", ""),
    };

    this.props.requestToken(cashOutTokenRequest);
  }

  private _inputHandler(id: string, newValue: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    new_input.valid = checkValidity(newValue, new_input.rules);
    new_input.value = newValue;

    this.props.onChangeInput(new_input);
  }
}

const mapStateToProps: (state: CajitaStore) => IPayoutsCashFormProps = (
  state: CajitaStore
): IPayoutsCashFormProps => ({
  ...state.payouts_cash,
  cashAmount:
    typeof state.config.amount === "object"
      ? calculateTotalAmount(state.config.amount as ITransferAmount)
      : state.config.amount,
  isLanguageToggleAvailable: true,
  currency: state.config.currency,
  disablePayButton: state.config.disablePayButton,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, IPayoutsCashActionCreator>
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): IPayoutsCashActionCreator =>
    dispatch(setDirty(payload)),
  requestToken: (payload: PayoutsCashTokenRequest): void =>
    dispatch(getPayoutCashToken(payload)),
  updatePayoutCashDocumentType: (payload: string): void =>
    dispatch(updatePayoutCashDocumentType(payload)),
});

const PayoutsCashComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize<IPayoutsCashFormProps & LocalizeContextProps>(PayoutCash));

export { PayoutsCashComponent };



// WEBPACK FOOTER //
// ./src/containers/PayoutsCash/PayoutsCashComponent.tsx